import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2, Gift, UserPlus } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ReferralRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [referrerName, setReferrerName] = useState('');

  useEffect(() => {
    validateCode();
  }, [code]);

  const validateCode = async () => {
    try {
      const res = await fetch(`${API_URL}/api/referral/${code}`);
      if (res.ok) {
        const data = await res.json();
        setReferrerName(data.referrer_name);
        // Store the referral code in localStorage
        localStorage.setItem('texhub_referral_code', data.code);
        setLoading(false);
      } else {
        setError('Código de referido no válido');
        setLoading(false);
      }
    } catch (err) {
      console.error('Error validating referral code:', err);
      setError('Error al validar el código');
      setLoading(false);
    }
  };

  const handleRegister = () => {
    navigate(`/register?ref=${code}`);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 to-white">
        <Loader2 className="w-8 h-8 animate-spin text-emerald-600" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 to-white p-4">
        <Card className="max-w-md w-full">
          <CardContent className="pt-6 text-center">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Gift className="w-8 h-8 text-red-500" />
            </div>
            <h1 className="text-xl font-bold text-slate-900 mb-2">Código no válido</h1>
            <p className="text-slate-600 mb-6">{error}</p>
            <Button onClick={() => navigate('/register')} className="w-full">
              Registrarse sin código
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 to-white p-4">
      <Card className="max-w-md w-full">
        <CardContent className="pt-6 text-center">
          <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Gift className="w-8 h-8 text-emerald-600" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mb-2">¡Invitación especial!</h1>
          <p className="text-slate-600 mb-2">
            <span className="font-semibold">{referrerName}</span> te invita a unirte a TexHub
          </p>
          <p className="text-sm text-slate-500 mb-6">
            La plataforma B2B más grande de la industria textil en México
          </p>
          
          <div className="bg-emerald-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-emerald-800">
              Al registrarte con este enlace, ayudas a {referrerName} a obtener beneficios exclusivos
            </p>
          </div>

          <Button 
            onClick={handleRegister} 
            className="w-full bg-emerald-600 hover:bg-emerald-700"
            size="lg"
          >
            <UserPlus className="w-4 h-4 mr-2" />
            Crear mi cuenta gratis
          </Button>
          
          <p className="text-xs text-slate-400 mt-4">
            Ya tienes cuenta? <a href="/login" className="text-emerald-600 hover:underline">Inicia sesión</a>
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default ReferralRedirect;
